// extracted by mini-css-extract-plugin
export default {"-large":"free-bgr-popup-module__-large--s1j95","container":"free-bgr-popup-module__container--YqQ1H","graphic":"free-bgr-popup-module__graphic--kRQCa"};